/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";

// core components

function FooterBlack() {
  return (
    <>
      <footer className="footer" data-background-color="black">
        <Container>
          <nav>
            <ul>
              <li>
                <a
                  href="/index"
                  target="_blank"
                >
                  The Deep VBC
                </a>
              </li>
              <li>
                <a
                  href="/index"
                  target="_blank"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="/blogs"
                  target="_blank"
                >
                  Blog
                </a>
              </li>
            </ul>
          </nav>
          <div className="copyright" id="copyright">
            © {new Date().getFullYear()}, Designed by{" "}
            <a
              href="https://www.gurueconsulting.com"
              target="_blank"
            >
              GuRue Consulting, LLC
            </a>
            . Coded by{" "}
            <a
              href="https://www.gurueconsulting.com"
              target="_blank"
            >
              The GuRue
            </a>
            .
          </div>
        </Container>
      </footer>
    </>
  );
}

export default FooterBlack;
